/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const PaymentTypeR = t.interface({
  payment_type: t.string
});

// optional attributes
const PaymentTypeO = t.partial({
  description: t.string
});

export const PaymentType = t.intersection(
  [PaymentTypeR, PaymentTypeO],
  "PaymentType"
);

export type PaymentType = t.TypeOf<typeof PaymentType>;
